import { render, staticRenderFns } from "./ParseForm.vue?vue&type=template&id=2bfe423c&scoped=true&"
import script from "./ParseForm.vue?vue&type=script&lang=js&"
export * from "./ParseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe423c",
  null
  
)

export default component.exports